type DefaultValue = boolean | (() => boolean);

// map of features' name to their backward compatible default value
// - some features had other mechanism to check availability before the Feature Policy API was available
// - some features were introduced before the Feature Policy API, should be true by default
// - some features may be introduced after the Feature Policy API, should be false by default
const features = {
  fullscreen: () => {
    if (typeof document.fullscreenEnabled === "boolean") {
      return document.fullscreenEnabled;
    }
    // Safari doesn't support fullscreenEnabled, but if the API is present we can assume it's supported
    return typeof document.documentElement.requestFullscreen === "function";
  },
} satisfies Record<string, DefaultValue>;

type Features = keyof typeof features;

// see: https://developer.mozilla.org/en-US/docs/Web/API/FeaturePolicy
type FeaturePolicy = {
  allowedFeatures(): Features[];
  allowsFeature(feature: Features): boolean;
  features(): Features[];
  // getAllowlistForFeature(feature: Features): string[];
};

const policy =
  typeof document !== "undefined"
    ? (document as Document & { featurePolicy?: FeaturePolicy }).featurePolicy
    : undefined;

export function allowsFeature(feature: Features): boolean {
  if (policy?.features().includes(feature)) {
    return policy.allowsFeature(feature);
  }
  if (feature in features) {
    const value = features[feature];
    return typeof value === "function" ? value() : value;
  }

  throw new Error(`Unknown feature: ${feature}`);
}
